var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandSquaredFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9343 1.5C21.3504 1.5 22.5 2.64967 22.5 4.06569V19.9343C22.5 21.3503 21.3503 22.5 19.9343 22.5H15.5675V14.5875H18.2991L18.8188 11.1987H15.5675V8.99958C15.5675 8.07251 16.0216 7.16881 17.478 7.16881H18.9563V4.28377C18.9563 4.28377 17.6146 4.05482 16.332 4.05482C13.6542 4.05482 11.9039 5.67777 11.9039 8.61592V11.1987H8.92731V14.5875H11.9039V22.5H4.06569C2.64967 22.5 1.5 21.3503 1.5 19.9343V4.06569C1.5 2.64967 2.64963 1.5 4.06569 1.5H19.9343V1.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSquaredFacebook);
export default __webpack_public_path__ + "static/media/brand_squared_facebook.deac49e4b753552780e135c277383330.svg";
export { ForwardRef as ReactComponent };